import React from 'react';
import { TableContainer, Box, Paper, Table, TableCell, TableHead, TableRow, TableBody, Button, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import useStyles from '../../../themes/makeStyles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 10,
    },
}))(TableCell);

export default function OkDamageCompletedInventory(props) {
    const warehouseData =
        JSON.parse(sessionStorage.getItem("warehouseData")) || {};

    const classes = useStyles();

    return (
        <TableContainer component={Paper} className={classes.container}>
            <Table className={classes.table} aria-label="simple table" stickyHeader>
                <TableHead>
                    <TableRow>
                        <StyledTableCell colSpan={6} align="center">
                            <b>Completed Current Inventory Ok/Shortage/Damage Table </b>
                        </StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>
                            <b>Type</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b> Condition of Material</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>No. of items</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Value (Cr.)</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>{warehouseData.warehouse_name.includes('Pravesh') ? "Qty (NOs)" : "Qty (MT)"}</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Space Occupied (Sq Ft.)</b>
                        </StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.CurInventCompletedOkDamageData && props.CurInventCompletedOkDamageData.length > 0 ?

                        props.CurInventCompletedOkDamageData.map(each =>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b>{(each.sap_type) ? each.sap_type : "COMPLETED"}</b>
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b> {(each.any_damage) ? each.any_damage : '-'} </b>
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b> {(each.no_of_items) ? each.no_of_items : 0} </b>
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b>{(each.value_in_cr) ? each.value_in_cr : 0}</b>
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b>{(each.unloading_quantity) ? each.unloading_quantity : 0}</b>
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <div>
                                        <b>{(each.bin_space_allocated) ? each.bin_space_allocated : 0}</b>
                                    </div>
                                </TableCell>
                            </TableRow>)
                        :
                        <h3><b>No Data in Ok/Shortage/Damage in Completed Status in Current Inventory</b></h3>}
                </TableBody>
            </Table>
        </TableContainer>
    );
} 